<div class="table" [class.table-fixed]="fixedHeader">
  <ng-content></ng-content>
</div>
